import { z } from "zod";

import { zSchema } from "../../../../entity";

const zIn = zSchema
  .pick({
    id: true,
  })
  .extend({
    services: z.array(
      zSchema.shape.services.element.pick({
        id: true,
        quantity: true,
      }),
    ),
  });
type In = z.infer<typeof zIn>;

const zOut = zSchema.pick({
  id: true,
  services: true,
});
type Out = z.infer<typeof zOut>;

export { zIn, zOut };
export type { In, Out };
